import {loadCarouselDependencies} from '@theme/carousel-dependencies';

const i = {
  isSectionActive() {
    var e;
    return !!(this.sectionActive && (e = this.container) != null && e.isConnected);
  },
  listenForSliderDemand() {
    this.sliderIntentController = new AbortController();
    const signal = this.sliderIntentController.signal;
    const demand = () => { if (this.isSectionActive() && !this.slider) this.initSlider(); };
    this.container.addEventListener('focusin', demand, {signal});
    this.container.addEventListener('pointerover', demand, {signal, passive: true});
  },
  withSliderDependencies(initialize) {
    if (this.sliderRequest) return this.sliderRequest.promise;
    const request = {};
    this.sliderRequest = request;
    request.promise = loadCarouselDependencies({progress: true}).then(dependencies => {
      if (this.sliderRequest === request && this.isSectionActive()) initialize(dependencies);
    }).catch(error => {
      if (this.sliderRequest === request && this.isSectionActive()) console.warn('Could not load carousel:', error);
    }).finally(() => {
      if (this.sliderRequest === request) this.sliderRequest = null;
    });
    return request.promise;
  },
  trackVisibleSliderCells() {
    const slider = this.slider;
    const update = () => {
      if (!slider?.cells) return;
      const start = slider.selectedSlide?.target || 0;
      const end = start + (slider.size?.innerWidth || 0);
      for (const cell of slider.cells) {
        // Containment overlaps groups on the final page. Every visible card
        // must remain available to assistive technology, not just its group.
        const visible = !slider.isActive || (cell.x < end - 1 && cell.x + cell.size.width > start + 1);
        if (visible) cell.element.removeAttribute('aria-hidden');
        else cell.element.setAttribute('aria-hidden', 'true');
      }
    };
    const settle = () => {
      // Flickity ignores resizing while animating without scheduling a retry.
      const width = slider.element.getBoundingClientRect().width;
      if (width > 0 && Math.abs(width - slider.size.width) > .5) slider.resize();
      update();
    };
    const events = ['select', 'resize', 'activate', 'deactivate'];
    for (const event of events) slider.on(event, update);
    slider.on('settle', settle);
    this.sliderVisibilityCleanup = () => {
      for (const event of events) slider.off(event, update);
      slider.off('settle', settle);
    };
    update();
  },
  scheduleSliderResize() {
    this.resizeFrame = requestAnimationFrame(() => {
      var e;
      (this.resizeFrame = null), this.isSectionActive() && ((e = this.slider) == null || e.resize());
    });
  },
  hideSection() {
    var e;
    (e = this.elements) != null &&
      e.section &&
      ((this.sectionHidden = !0), (this.elements.section.style.display = 'none'), this.elements.section.setAttribute('inert', ''));
  },
  showSection() {
    var e;
    (e = this.elements) != null &&
      e.section &&
      ((this.sectionHidden = !1), this.elements.section.style.removeProperty('display'), this.elements.section.removeAttribute('inert'));
  },
  destroySlider() {
    var e, t;
    this.sliderVisibilityCleanup?.();
    this.sliderVisibilityCleanup = null;
    cancelAnimationFrame(this.resizeFrame),
      (this.resizeFrame = null),
      (e = this.progressIndicator) == null || e.destroy(),
      (this.progressIndicator = null),
      (t = this.slider) == null || t.destroy(),
      (this.slider = null);
  },
  teardown() {
    var e;
    (this.sectionActive = !1),
      (this.sliderRequest = null),
      this.sliderIntentController?.abort(),
      (this.sliderIntentController = null),
      this.visibilityCleanup?.(),
      (this.visibilityCleanup = null),
      (this.sectionVisible = !1),
      this.sectionHidden && this.showSection(),
      (e = this.requestController) == null || e.abort(),
      (this.requestController = null),
      cancelAnimationFrame(this.initFrame),
      (this.initFrame = null),
      this.destroySlider();
  },
  onUnload() {
    this.teardown();
  },
};
export {i as s};
